import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { MyInstituteService } from '../../../services/institute/myinstitute/my-institute.service';
import { Institute } from '../../../models/institute/randomInstituteResponse';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Course } from '../../../models/enums/enums';
import { StudentCheckListService } from '../../../services/account/student-check-list.service';
import { StudentInstituteCheckListDTO } from '../../../models/account/checkList/studentInstituteCheckListDTO';
import { InstituteService } from '../../../services/institute/institute.service';
import { InstituteCheckListDTO } from '../../../models/institute/checkList/instituteCheckListDto';
import { CompleteProfileService } from '../../../services/account/complete-profile.service';
import { MyInstitutesSelectors } from '../../../states/myInstitutes/my-institute-selector';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AdditionalInformation } from '../../../models/enums/additionalInformation';
import { AdditionalInformationRightSectionComponent } from "../additional-information-right-section/additional-information-right-section.component";
import { UserSelectors } from '../../../states/user/user-selector';
import { iif, map, of, switchMap, take, tap } from 'rxjs';
import { CourseLevelEnum } from '../../../models/enums/courseLevelEnum';
import { ToastModule } from 'primeng/toast';
enum selectedTab {
  checkList,
  additionalInfo
}

@Component({
  selector: 'app-check-list-section',
  standalone: true,
  imports: [ButtonModule, DropdownModule, InputTextModule, CheckboxModule, CommonModule, ReactiveFormsModule, AdditionalInformationRightSectionComponent, ToastModule],
  templateUrl: './check-list-section.component.html',
  styleUrl: './check-list-section.component.scss',
  providers: [MessageService]
})
export class CheckListSectionComponent implements OnInit {

  infotype = AdditionalInformation;
  selectedTab = selectedTab;
  currentSelectedTab = selectedTab.checkList;

  studentId: string = '';
  myInstitutes: Institute[] = [];
  selectedInstitute: Institute | null = null;
  isLoading = true;
  applyingForLevel!: CourseLevelEnum;
  applyingForCourseName: string = '';
  Course = Course;
  daysLeft!: number | null;
  studentInstituteCheckList?: StudentInstituteCheckListDTO;
  instituteCheckList?: InstituteCheckListDTO;
  submitted: boolean = false;
  isSaving: boolean = false;

  checklistForm: FormGroup = this.formBuilder.group({
    essayPilot: [null],
    lORs: [null],
    personalDocuments: [null],
    testScores: [null],
    financialAids: [null],
    applicationForms: [null],
  });

  constructor(
    private myInstituteService: MyInstituteService,
    private formBuilder: FormBuilder,
    private store: Store,
    private route: ActivatedRoute,
    private studentCheckListService: StudentCheckListService,
    private instituteService: InstituteService,
    private completeProfileService: CompleteProfileService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.studentId = this.route.snapshot.paramMap.get('id') || '';
    this.getCheckList(this.studentId);
  }

  // getCheckList(studentId: string) {
  //   this.completeProfileService.getDemography(studentId).pipe(
  //     switchMap(demography =>
  //       this.store.select(MyInstitutesSelectors.getMyInstitute).pipe(
  //         take(1),
  //         switchMap(institutes =>
  //           iif(
  //             () => institutes?.items?.length > 0,
  //             of({ demography, institutes }),
  //             this.myInstituteService.getMyInstitutesByid(studentId).pipe(
  //               tap((apiInstitutes: Institute[]) => {
  //                 this.myInstitutes = apiInstitutes;
  //               }),
  //               map(apiInstitutes => ({
  //                 demography,
  //                 institutes: { items: apiInstitutes }
  //               }))
  //             )
  //           )
  //         )
  //       )
  //     )
  //   ).subscribe({
  //     next: ({ demography, institutes }) => {
  //       this.applyingForLevel = this.mapDegreePreference(demography?.degreePreference);
  //       this.myInstitutes = institutes?.items || [];

  //       if (this.myInstitutes.length > 0) {
  //         this.selectedInstitute = this.myInstitutes[0];
  //         this.calculateDaysLeft(this.selectedInstitute.applicationDeadlineRegularDecision || '');
  //         this.loadInstituteCheckList(this.selectedInstitute);
  //       }

  //       this.isLoading = false;
  //     },
  //     error: (error) => {
  //       this.isLoading = false;
  //       console.warn('Error while retrieving checklist:', error);
  //     }
  //   });
  // }


  getCheckList(studentId: string) {
    this.completeProfileService.getDemography(studentId).pipe(
      switchMap(demography =>
        this.myInstituteService.getMyInstitutesByid(studentId).pipe(
          tap((apiInstitutes: Institute[]) => {
            this.myInstitutes = apiInstitutes;
          }),
          map(apiInstitutes => ({
            demography,
            institutes: { items: apiInstitutes }
          }))
        )
      )
    ).subscribe({
      next: ({ demography, institutes }) => {
        this.applyingForLevel = demography.degreePreference;
        this.applyingForCourseName = demography?.intendedMajor ?? '';
        this.myInstitutes = institutes?.items || [];

        if (this.myInstitutes.length > 0) {
          this.selectedInstitute = this.myInstitutes[0];
          this.calculateDaysLeft(this.selectedInstitute.applicationDeadlineRegularDecision || '');
          this.loadInstituteCheckList(this.selectedInstitute);
        }

        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        console.warn('Error while retrieving checklist:', error);
      }
    });
  }


  private mapDegreePreference(degreePreference?: string): Course {
    switch (degreePreference) {
      case 'Bachelors':
        return Course.Bachelors;
      case 'Masters':
        return Course.Masters;
      case 'Certification Course':
        return Course.CertificationCourse;
      default:
        return Course.Phd;
    }
  }

  loadInstituteCheckList(institute: Institute): void {
    this.currentSelectedTab = selectedTab.checkList;
    this.isLoading = true;
    this.calculateDaysLeft(institute.applicationDeadlineRegularDecision || '');
    this.selectedInstitute = institute;
    
    const courseLevel = institute.courseLevel ?? this.applyingForLevel;
    const courseName = institute.courseName ?? this.applyingForCourseName;

    this.instituteService
      .getCheckList({
        instituteId: institute.id,
        courseLevel: courseLevel,
        courseName: courseName
      })
      .subscribe({
        next: (result) => {
          this.isLoading = false;
          this.instituteCheckList = result;
          this.loadStudentInstituteCheckList();
        },
        error: (error) => {
          this.isLoading = false;
          console.warn('Error while retrieving checklist:', error);
        },
      });
  }

  private calculateDaysLeft(deadline: string) {
    const today = new Date();
    const currentYear = today.getFullYear();

    // Convert "November 30" to a Date object
    const targetDate = new Date(`${deadline}, ${currentYear}`);

    // Check if the parsed date is valid
    if (isNaN(targetDate.getTime())) {
      console.error('Invalid date format');
      return;
    }

    // Calculate the difference in days
    const timeDiff = targetDate.getTime() - today.getTime();
    this.daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  }

  private loadStudentInstituteCheckList(): void {
    if (!this.selectedInstitute) return;

    const courseLevel = this.selectedInstitute.courseLevel ?? this.applyingForLevel;
    const courseName = this.selectedInstitute.courseName ?? this.applyingForCourseName;

    this.studentCheckListService.getStudentCheckList({
      instituteId: this.selectedInstitute.id,
      courseLevel: courseLevel,
      courseName: courseName
    }, this.studentId).subscribe({
      next: (response) => {
        this.studentInstituteCheckList = response;
        this.initializeChecklistForm();
      },
      error: (err) => {
        console.warn('Error while retrieving student checklist:', err);
      },
    });
  }

  private initializeChecklistForm(): void {
    if (!this.studentInstituteCheckList) return;

    this.checklistForm = this.formBuilder.group({
      essayPilot: [this.studentInstituteCheckList.essayPilot, Validators.required],
      lORs: [this.studentInstituteCheckList.lORs, Validators.required],
      personalDocuments: [this.studentInstituteCheckList.personalDocuments, Validators.required],
      testScores: [this.studentInstituteCheckList.testScores, Validators.required],
      financialAids: [this.studentInstituteCheckList.financialAid, Validators.required],
      applicationForms: [this.studentInstituteCheckList.applicationForms, Validators.required],
    });
  }

  saveStudentChecklist(): void {
    this.submitted = true;
    if (this.checklistForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill all required fields.',
      });
      return;
    }
    this.isSaving = true;

    const courseLevel = this.selectedInstitute?.courseLevel ?? this.applyingForLevel;
    const courseName = this.selectedInstitute?.courseName ?? this.applyingForCourseName;

    this.studentCheckListService.updateStudentCheckList({
      applicationForms: this.checklistForm.value.applicationForms ?? [],
      courseLevel: courseLevel,
      courseName: courseName,
      essayPilot: this.checklistForm.value.essayPilot,
      financialAid: this.checklistForm.value.financialAids,
      instituteId: this.selectedInstitute?.id ?? '',
      lORs: this.checklistForm.value.lORs,
      personalDocuments: this.checklistForm.value.personalDocuments,
      testScores: this.checklistForm.value.testScores
    }, this.studentId).subscribe({
      next: (response) => {
        this.isSaving = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Checklist details are updated!',
        });
      },
      error: (error) => {
        this.isSaving = false;
        console.warn(`error while processing request ${error}`);
      }
    });
  }

  openAdditionalInfo() {
    this.currentSelectedTab = selectedTab.additionalInfo;
  }

  deleteCollege(institute: Institute): void {
    if (!institute.id) return;
    this.myInstituteService.removeMyInstitute(institute.id, this.studentId).subscribe({
      next: () => {
        this.myInstitutes = this.myInstitutes.filter(i => i.id !== institute.id);
        if (this.selectedInstitute?.id === institute.id) {
          this.selectedInstitute = this.myInstitutes[0] ?? null;
          if (this.selectedInstitute) {
            this.loadInstituteCheckList(this.selectedInstitute);
          } else {
            this.studentInstituteCheckList = undefined;
            this.instituteCheckList = undefined;
          }
        }
        this.messageService.add({ severity: 'success', summary: 'Removed', detail: `${institute.instituteName || 'College'} removed.` });
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to remove college.' });
      }
    });
  }
}
